import { takeEvery, select, all, takeLatest, put, cancel, fork, take } from 'redux-saga/effects';
import {
  AuthorizationApi,

  loginAction,

  createLoginSaga, refreshAccessToken,
  RoleNames,
} from '@smorder/logic';

import {
  navigate,
} from '../reducers/navigator.reducers';

import {
  loadOrders as loadOrdersAction,
  loadOrder as loadOrderAction,
  proceedOrder as proceedOrderAction,
  declineOrder as declineOrderAction,
  startPrintOrder as startPrintOrderAction,
  startPrintControlList as startPrintControlListAction,
  openReportDialog as openReportDialogAction,
  initPrinter as initPrinterAction,
  initPrinterFailed as initPrinterFailedAction,
  printOrderFailed as printOrderFailedAction,
  reconnectPrinter as reconnectPrinterAction,
  reconnectPrinterFinished as reconnectPrinterFinishedAction,
  printArticleList as printArticleListAction,
  actionOnOrdercard as actionOnOrdercardAction,
  setMode as setModeAction,
  resetOrderSearchValue as resetOrderSearchValueAction,
  setDeliveryTimeAction,
  downloadLabels as downloadLabelsAction,
  startPrintProductLabels as startPrintProductLabelsAction,
  printAllLabels,
  proceedAllVisibleOrders as proceedAllVisibleOrdersAction,
  startCheckExportPossible as startCheckExportPossibleAction,
} from '../reducers/order.reducers';

import {
  loadOrders as loadSignageOrdersAction,
  loadLocation as loadLocationAction,
} from '../reducers/signage.reducers';

import {
  loadMenuTreeAction,
  updateMenuAction,
  updateCategoryAction,
  updateMenuEntryAction,
  loadProductsAction,
  updateProductAction,
  updateMenusAction,
  updateCategoriesAction,
  updateMenuEntriesAction,
  updateProductsAction,
  loadProductionPlacesAction,
} from '../reducers/menu.reducers';

import {
  loadMenuTree,
  updateMenu,
  updateCategory,
  updateMenuEntry,
  loadProducts,
  updateProduct,
  updateMenus,
  updateCategories,
  updateMenuEntries,
  updateProducts,
  loadProductionPlaces,
} from './menu.sagas';

import {
  loadOrders,
  loadOrder,
  proceedOrder,
  declineOrder,
  handleScan,
  handleOrderCardAction,
  setMode,
  scheduleSearchFieldReset,
  setDeliveryTime,
  loadReports,
  downloadLabels,
  proceedAllVisibleOrders,
  startCheckExportPossible,
}
  from './order.sagas';

  import {
  printOrder,
  initPrinter,
  initPrinterFailed,
  printFailed,
  reconnect,
  reconnectFinished,
  printArticleList,
  printControlList,
  printProductLabels,
} from './print.sagas';

import { loadSignageOrders, loadLocation } from './signage.sagas';

import { closeAlert as closeAlertAction } from '../reducers/alert.reducers';
import { closeAlert } from '../sagas/alert.sagas';

import {
  loadUiOptions as loadUiOptionsAction,
  setPendingScannerInput as setPendingScannerInputAction,
  toggleFullScreen as toggleFullScreenAction,
} from '../reducers/app.reducers';

import { loadUiOptions, toggleFullScreen } from '../sagas/app.sagas';

import config from '../../run-config';

import OrderApi from '../api/order';
import SignageApi from '../api/signage';
import AppApi from '../api/app';
import MenuApi from '../api/menu';
import { call } from 'ramda';

const allowedRoles = [RoleNames.Waiter];

export default function* rootSaga() {
  let authApi = null;
  let orderApi = null;
  let signageApi = null;
  let appApi = null;
  let menuGQLApi = null;
  let menuApi = null;

  function* tokenProvider() {
    const { accessToken, refreshToken, expiresAt } = yield select(state => state.authentication);
    return {
      accessToken,
      refreshToken,
      expiresAt,
    };
  }

  function* tokenRefreshTask() {
    return yield refreshAccessToken(authApi);
  }

  function optionProvider() {
    return {
      tokenRefreshTask,
      tokenProvider,
    };
  }

  authApi = new AuthorizationApi(config.apiHost, optionProvider, null, null, config.clientName);
  orderApi = new OrderApi(config.apiHost, optionProvider, null, null, config.clientName);
  signageApi = new SignageApi(config.apiHost, optionProvider, null, null, config.clientName);
  appApi = new AppApi(config.apiHost, optionProvider, null, null, config.clientName);
  menuApi = new MenuApi(config.apiHost, optionProvider, null, null, config.clientName);
  menuGQLApi = new MenuApi(config.smorderGraphHost, optionProvider, null, null, config.clientName);

  const login = createLoginSaga(allowedRoles, !config.onPremiseMode && [put(navigate({ route: '/' }))]);


function selectId(action) {
  const { type, payload } = action;
  const { item } = payload;
  const identifier = payload.identifier || 'id';
  const id = item[identifier];
  return {
    key: `${type}_${id}`,
    id,
  };
}

  function takeLatestPerKey(patternOrChannel, worker, ...args) {
    return fork(function* () {
      const tasks = {};
      while (true) {
        const action = yield take(patternOrChannel);
        const { key } = yield call(selectId, action);
        if (tasks[key]) {
          yield cancel(tasks[key]);
        }
        tasks[key] = yield fork(worker, ...args, action);
      }
    });
  }
  

  yield all([
    // auth
    takeEvery(loginAction.INIT, login, authApi),

    // orders
    takeLatest(loadOrdersAction, loadOrders, orderApi),
    takeEvery(loadOrderAction, loadOrder, orderApi),
    takeLatestPerKey(proceedOrderAction, proceedOrder, orderApi),
    takeLatest(proceedAllVisibleOrdersAction, proceedAllVisibleOrders, orderApi),
    takeEvery(declineOrderAction, declineOrder, orderApi),
    takeEvery(actionOnOrdercardAction, handleOrderCardAction, orderApi),
    takeEvery(setModeAction, setMode, orderApi),
    takeLatest(resetOrderSearchValueAction, scheduleSearchFieldReset, orderApi),
    takeEvery(setDeliveryTimeAction.INIT, setDeliveryTime, orderApi),

    // printer
    takeEvery(startPrintOrderAction, printOrder, orderApi),
    takeEvery(startPrintProductLabelsAction, printProductLabels, orderApi),
    takeEvery(initPrinterAction, initPrinter, orderApi),
    takeEvery(initPrinterFailedAction, initPrinterFailed, orderApi),
    takeEvery(printOrderFailedAction, printFailed, orderApi),
    takeEvery(reconnectPrinterAction, reconnect, orderApi),
    takeEvery(reconnectPrinterFinishedAction, reconnectFinished, orderApi),
    takeEvery(printArticleListAction, printArticleList, orderApi),
    takeEvery(downloadLabelsAction, downloadLabels, orderApi),
    takeEvery(printAllLabels, printAllLabels, orderApi),

    // ninjas
    takeEvery(startCheckExportPossibleAction, startCheckExportPossible, orderApi),

    // reports
    takeEvery(startPrintControlListAction, printControlList, orderApi),
    takeEvery(openReportDialogAction, loadReports, orderApi),


    // alert
    takeEvery(closeAlertAction, closeAlert),

    // signage
    takeEvery(loadSignageOrdersAction, loadSignageOrders, signageApi),

    // app
    takeEvery(loadUiOptionsAction, loadUiOptions, appApi),
    takeEvery(toggleFullScreenAction, toggleFullScreen, appApi),

    // scanner
    takeEvery(setPendingScannerInputAction, handleScan, orderApi),

    // location
    takeLatest(loadLocationAction, loadLocation, signageApi),

    // Menu
    takeEvery(loadMenuTreeAction.INIT, loadMenuTree, menuGQLApi),
    takeEvery(updateMenuAction.INIT, updateMenu, menuApi),
    takeEvery(updateCategoryAction.INIT, updateCategory, menuApi),
    takeEvery(updateMenuEntryAction.INIT, updateMenuEntry, menuApi),
    takeEvery(loadProductsAction.INIT, loadProducts, menuApi),
    takeEvery(updateProductAction.INIT, updateProduct, menuApi),
    takeEvery(updateMenusAction.INIT, updateMenus, menuApi),
    takeEvery(updateCategoriesAction.INIT, updateCategories, menuApi),
    takeEvery(updateMenuEntriesAction.INIT, updateMenuEntries, menuApi),
    takeEvery(updateProductsAction.INIT, updateProducts, menuApi),
    takeEvery(loadProductionPlacesAction.INIT, loadProductionPlaces, menuApi),
  ]);
}
